module.exports = __webpack_public_path__ + "img/advantage-img-3.96ed0102.png";